import { render } from "./StaticSearchSkill.vue?vue&type=template&id=f168f254&scoped=true"
import script from "./StaticSearchSkill.vue?vue&type=script&lang=js"
export * from "./StaticSearchSkill.vue?vue&type=script&lang=js"

import "./StaticSearchSkill.vue?vue&type=style&index=0&id=f168f254&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f168f254"]])

export default __exports__